<template>
    <v-container>
        <v-card elevation="0">
            <v-card-title>
                <pre><v-toolbar-title><h4>Agregar vacaciones</h4></v-toolbar-title></pre>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-date-picker
                            multiple
                            v-model="picker"
                            first-day-of-week="1"
                        ></v-date-picker>
                        <div class="mt-3">
                            <v-btn
                                class="white--text"
                                @click="saveVacations"
                                color="success"
                                block
                                >Añadir</v-btn
                            >
                            <v-btn
                                class="white--text mt-2"
                                @click="imprimirVacaciones"
                                color="blue"
                                block
                                >Imprimir</v-btn
                            >
                        </div>
                    </v-col>

                    <v-col cols="12" md="8">
                        <div style="margin-bottom: 20px; text-align: center;">
                            <v-card elevation="2" color="#1d2735" class="pa-3">
                                <div class="white--text">
                                    <h3 style="margin: 0;">Total días disfrutados: {{ totalDiasDisfrutados }}</h3>
                                </div>
                            </v-card>
                        </div>
                        <div class="picker-header">
                            <button type="button" @click="previousWeek()">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="picker-header-arrow"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    stroke-width="2"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M15 19l-7-7 7-7"
                                    />
                                </svg>
                            </button>
                            <h2>
                                {{ year }}
                            </h2>
                            <button type="button" @click="nextWeek()">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="picker-header-arrow"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    stroke-width="2"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M9 5l7 7-7 7"
                                    />
                                </svg>
                            </button>
                        </div>
                        <v-data-table :headers="headers" :items="vacaciones">
                            <template v-slot:item.fecha="{ item }">
                                {{ item.fecha | format_date }}
                            </template>
                            <template v-slot:item.action="{ item }">
                                <v-icon
                                    @click="openModal(item)"
                                    small
                                    class="mr-2"
                                    color="red"
                                    style="font-size: 25px"
                                    title="BORRAR"
                                    >mdi-trash-can</v-icon
                                >
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer />
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteVacacion()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
export default {
    props: ["user"],
    data() {
        return {
            headers: [
                { text: "Fecha", value: "fecha", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            vacaciones: [],
            picker: [],
            year: new Date().getFullYear(),
            dialog: false,
            selectedItem: {},
        };
    },
    created() {
        this.getVacations();
    },
    computed: {
        rol: function () {
            return localStorage.getItem("real_role") ?? -1;
        },
        totalDiasDisfrutados() {
            return this.vacaciones.length;
        },
    },
    methods: {
        deleteVacacion() {
            axios.get(`api/delete-vacaciones/${this.selectedItem.id}`).then(
                (res) => {
                    this.getVacations();

                    this.$toast.sucs("Vacaciones eliminada con éxito");
                    this.dialog = false;
                },
                (err) => {
                    this.$toast.error("Error eliminando las vacaciones");
                }
            );
            //this.getUsuarios();
        },
        openModal(item) {
            this.selectedItem = item;
            this.dialog = true;
        },
        previousWeek() {
            this.year--;
            this.getVacations();
        },
        nextWeek() {
            this.year++;
            this.getVacations();
        },
        getVacations() {
            this.$emit("update");
            console.log("vacaciones");
            axios
                .get(
                    `api/get-vacaciones?id_usuario=${this.user.id}&year=${this.year}`
                )
                .then((res) => {
                    this.vacaciones = res.data.data;
                    console.log(this.vacaciones);
                });
        },
        saveVacations() {
            axios
                .post(`api/save-vacaciones`, {
                    vacaciones: this.picker,
                    id_usuario: this.user.id,
                })
                .then((res) => {
                    this.getVacations();
                });
        },
        imprimirVacaciones() {
            const fecha = new Date().toLocaleDateString('es-ES');
            const nombreEmpleado = this.user.name || 'Sin nombre';
            const totalDias = this.totalDiasDisfrutados;
            
            let html = `
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <title>Vacaciones - ${nombreEmpleado}</title>
                    <style>
                        @media print {
                            @page {
                                margin: 1.5cm;
                                size: A4 portrait;
                            }
                            body {
                                margin: 0;
                                padding: 0;
                            }
                        }
                        body {
                            font-family: Arial, sans-serif;
                            font-size: 12px;
                            padding: 20px;
                        }
                        .header {
                            text-align: center;
                            margin-bottom: 30px;
                            border-bottom: 2px solid #1d2735;
                            padding-bottom: 15px;
                        }
                        .header h1 {
                            margin: 0;
                            color: #1d2735;
                            font-size: 24px;
                        }
                        .info-empleado {
                            background-color: #f5f5f5;
                            padding: 15px;
                            border-radius: 5px;
                            margin-bottom: 20px;
                        }
                        .info-empleado h3 {
                            margin-top: 0;
                            color: #1d2735;
                        }
                        .info-row {
                            display: flex;
                            justify-content: space-between;
                            margin-bottom: 8px;
                        }
                        .info-label {
                            font-weight: bold;
                            color: #555;
                        }
                        .total-dias {
                            background-color: #1d2735;
                            color: white;
                            padding: 15px;
                            border-radius: 5px;
                            text-align: center;
                            margin-bottom: 20px;
                            font-size: 18px;
                            font-weight: bold;
                        }
                        table {
                            width: 100%;
                            border-collapse: collapse;
                            margin-top: 20px;
                        }
                        th, td {
                            border: 1px solid #ddd;
                            padding: 10px;
                            text-align: left;
                        }
                        th {
                            background-color: #1d2735;
                            color: white;
                            font-weight: bold;
                            text-align: center;
                        }
                        tr:nth-child(even) {
                            background-color: #f2f2f2;
                        }
                        .footer {
                            margin-top: 30px;
                            text-align: center;
                            font-size: 10px;
                            color: #666;
                        }
                    </style>
                </head>
                <body>
                    <div class="header">
                        <h1>Registro de Vacaciones</h1>
                        <p>Fecha de impresión: ${fecha}</p>
                    </div>
                    
                    <div class="info-empleado">
                        <h3>Datos del Empleado</h3>
                        <div class="info-row">
                            <span class="info-label">Nombre:</span>
                            <span>${nombreEmpleado}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Año:</span>
                            <span>${this.year}</span>
                        </div>
                    </div>
                    
                    <div class="total-dias">
                        Total de días disfrutados: ${totalDias} días
                    </div>
                    
                    <table>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Fecha</th>
                            </tr>
                        </thead>
                        <tbody>
            `;
            
            this.vacaciones.forEach((vacacion, index) => {
                let fechaFormateada = '';
                if (vacacion.fecha) {
                    if (this.$options.filters && this.$options.filters.format_date) {
                        fechaFormateada = this.$options.filters.format_date(vacacion.fecha);
                    } else {
                        const str = vacacion.fecha.split('-');
                        fechaFormateada = `${str[2]}-${str[1]}-${str[0]}`;
                    }
                }
                
                html += `
                    <tr>
                        <td style="text-align: center;">${index + 1}</td>
                        <td>${fechaFormateada}</td>
                    </tr>
                `;
            });
            
            html += `
                        </tbody>
                    </table>
                    
                    <div class="footer">
                        <p>Total de días de vacaciones disfrutados en ${this.year}: ${totalDias} días</p>
                    </div>
                </body>
                </html>
            `;
            
            const ventanaImpresion = window.open('', '_blank');
            ventanaImpresion.document.write(html);
            ventanaImpresion.document.close();
            
            setTimeout(() => {
                ventanaImpresion.print();
            }, 250);
        },
    },
};
</script>
